<template>
  <material-card
    color="primary"
    :icon="icon"
    class="mx-auto"
  >
    <v-container v-if="response.status === 'Succeeded'">
      <v-card
        class="mx-auto mb-14"
        max-width="500"
        color="green"
        dark
      >
        <v-card-title>
          <h1>{{ $t('successful_payment') }}</h1>
        </v-card-title>
        <v-card-text>
          <p class="font-weight-bold">
            {{ $t('payment_transaction_id') }}: {{ response.transaction_id }} <br>
            {{ $t('external_reference_number') }}: {{ response.order_id }} <br>
            {{ $t('transaction_date') }}: {{ response.transaction_date }} <br>
            {{ $t('amount_paid') }}: {{ response.transaction_value }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="escape"
          >
            {{ $t('back_to_my_transactions') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <v-container v-else-if="response.status === 'Canceled'">
      <v-card
        class="mx-auto"
        max-width="500"
        color="red"
        dark
      >
        <v-card-title>
          <h1>{{ $t('unsuccess payment') }}</h1>
        </v-card-title>
        <v-card-text>
          <p class="font-weight-bold">
            {{ $t('payment_transaction_id') }}: {{ response.transaction_id }} <br>
            {{ $t('external_reference_number') }}: {{ response.order_id }} <br>
            {{ $t('transaction_date') }}: {{ response.transaction_date }} <br>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="escape"
          >
            {{ $t('back_to_my_transactions') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </material-card>
</template>

<script>
  // Utilities
  import { call, sync } from 'vuex-pathify'

  export default {
    name: 'PaymentStart',
    data: function () {
      return {
        icon: '$payment',
        title: 'payment',
        new_item: true,
        prevRoute: '',
        response: [],
        saved: false,
        provider: null,
        payment_id: null,
      }
    },
    computed: {
      loading: sync('app/loading'),
    },
    mounted () {
      console.log(this.$route)
      this.loading = true
      this.provider = this.$route.params.provider
      this.payment_id = this.$route.params.id
      // this.response = ':)'
      setTimeout(() => { this.status() }, 5000)
    },
    methods: {
      statusPayment: call('payment/status'),
      async status () {
        this.loading = true
        await this.statusPayment(
          {
            provider: this.provider,
            payment_id: this.payment_id,
          },
        ).then(response => {
          this.response = response
        }).catch(e => {
          console.log('Újrapróbálás')
          this.loading = true
          setTimeout(() => { this.status() }, 5000)
          // this.status()
        })
      },
      escape () {
        this.$router.push('/profile/transactions').catch(() => {})
      },
    },
  }
</script>
